import { cx } from 'cva';
import { type FunctionComponent } from 'react';
import {
  type MessageInputProps,
  TextareaComposer,
  useMessageComposer,
  useMessageComposerHasSendableData,
  useMessageInputContext,
} from 'stream-chat-react';
import { useTranslation } from '../../i18n/resources';
import { EmojiPicker } from '../EmojiPicker/EmojiPicker';
import { SendButton } from '../SendButton/SendButton';
import styles from './MessageInput.module.css';

export const MessageInput: FunctionComponent<MessageInputProps> = () => {
  const { handleSubmit } = useMessageInputContext();
  const hasSendableData = useMessageComposerHasSendableData();
  const composer = useMessageComposer();
  const { t } = useTranslation();

  return (
    <div
      className={cx(
        styles.root,
        composer.threadId ? styles.thread : styles.message,
      )}
    >
      {composer.threadId === null && (
        <div className={styles.disclaimer}>
          {t('prayerStream', 'disclaimer')}
        </div>
      )}
      <div className={styles.inputFields}>
        <EmojiPicker />
        <div className={styles.composer}>
          <TextareaComposer
            maxRows={8}
            placeholder={t('prayerStream', 'send_a_message')}
          />
        </div>
        <SendButton disabled={!hasSendableData} onClick={handleSubmit} />
      </div>
    </div>
  );
};
